import React, {Component} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import BPContestPhaseRow from "../BPContestPhaseRow";
import BPContestEvidenceRow from "../BPContestEvidenceRow";
import Loading from "../../Loading";

class BPContestDetailByAGBHO extends Component{
    constructor(props) {
        super(props);
        const INITIAL_ITEM = {
            id:'',
            name:'',
            startDate:null,
            endDate:null,
            closeDate:null,
            closeConfirmDate:null,
            memoId:'',
            memoFileName:'',
            memoFilePath:'',
            status:'',
            remark:'',
            bankCode:'',
            createdBy:'',
            updatedBy:'',
            createdDate:'',
            updatedDate:'',
        }
        this.state = {
            isLoading: false,
            successMessage: '',
            errorMessage: '',
            item:INITIAL_ITEM,
            phases: [],
            evidences: [],
            selectedFile: null,
            isSelectedFile: false,
        }
        this.handleLoadContest = this.handleLoadContest.bind(this);
        this.handleLoadPhases = this.handleLoadPhases.bind(this);
        this.handleLoadEvidences = this.handleLoadEvidences.bind(this);
        this.handleLoadData = this.handleLoadData.bind(this);
        this.handleLoadMessage = this.handleLoadMessage.bind(this);
    }
    componentDidMount() {
        this.handleLoadData(this.props?.id);
    }

    handleLoadData = (contestId) =>{
        this.handleLoadContest(contestId)
        this.handleLoadPhases(contestId)
        this.handleLoadEvidences(contestId)
    }
    handleLoadContest(phaseId) {
        this.setState({isLoading: true})
        const responseContest = axios.get('/api/bankportal/contest/'+phaseId+'/load')
            .then(response =>{
                if(response?.data === ''){
                    this.setState({errorMessahe: 'Không tìm thấy dữ liệu!', successMessage:'', isLoading: false})
                    return;
                }
                this.setState({item: response?.data, isLoading: false})
            })
            .catch(error =>{
                console.error('Error loading contest!', error);
                this.setState({errorMessage: error.message,successMessage:'', isLoading: false});
            })
    }

    handleLoadPhases = (contestId) =>{
        axios.get('/api/bankportal/contest/'+contestId+'/phase/list')
            .then(response =>{
                this.setState({phases: response?.data?.listPhase})
            })
            .catch(error =>{
                console.error('Error loading phases!', error);
                this.setState({errorMessage: error.message,successMessage:''});
            })
    }

    handleLoadEvidences = (contestId) =>{
        axios.get('/api/bankportal/contest/'+contestId+'/evidence/list')
            .then(response =>{
                this.setState({evidences: response?.data?.listEvidence})
            })
            .catch(error =>{
                console.error('Error loading evidences!', error);
                this.setState({errorMessage: error.message,successMessage:''});
            })
    }

    handleLoadMessage = (message) =>{
        this.setState({successMessage: message})
    }

    handleLoading = (loading) =>{
        this.setState({isLoading: loading})
    }


    render() {
        const {item, isLoading,errorMessage, successMessage, phases, evidences} = this.state;
        if(isLoading === true) return <Loading />
        return (
            <div className={'container'}>
                <div>
                    <div>
                        { !!errorMessage && <div className={"alert alert-warning"} role="alert">{ errorMessage }</div> }
                        { !!successMessage && <div className={"alert alert-info"} role="alert">{ successMessage }</div> }
                        <h2 className="m-3 text-primary">CHI TIẾT CHƯƠNG TRÌNH THI ĐUA</h2>
                        <form>
                            <input type="hidden" value={item?.id} />
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Ngân hàng :</label>
                                <div className="col-sm-9">
                                    <span>{item?.bankCode === 'AGB'?'Agribank':''}</span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="name">Tên thi đua :</label>
                                <div className="col-sm-9">
                                    <span>{item?.name}</span>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="status">Tình trạng xử lý:</label>
                                <div className="col-sm-9">
                                    <select disabled={true} id="status" className="form-control w-25" value={item?.status}>
                                        <option value="PROCESSING">Đang diễn ra</option>
                                        <option value="WAITING_APPROVAL">Chờ chốt kết quả</option>
                                        <option value="WAITING_FEEDBACK">Chờ phản hồi</option>
                                        <option value="COMPLETED">Kết thúc</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="status">Danh sách đợt:</label>
                                <div className="col-sm-9">
                                    <table className={'table table-bordered table-hover'}>
                                        <thead className='bg-secondary text-white'>
                                        <tr>
                                            <th>STT</th>
                                            <th>Tên đợt</th>
                                            <th>Mô tả</th>
                                            <th>Ngày tạo</th>
                                            <th>Thao tác</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {!!phases && phases.map((phase, index) =>
                                            <BPContestPhaseRow
                                               key={'Phase_'+phase?.bankCode+'_'+phase?.id}
                                               item={phase} index={index}
                                               onLoadMessage={this.handleLoadMessage}
                                               onLoading={this.handleLoading}
                                               onLoadPhases={this.handleLoadPhases}
                                               contestId={item?.id} />
                                           )
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="control-label col-sm-3" htmlFor="status">Danh sách tập tin đính kèm:</label>
                                <div className="col-sm-9">
                                    <table className={'table table-bordered table-hover'}>
                                        <thead className='bg-secondary text-white'>
                                        <tr>
                                            <th>STT</th>
                                            <th>Tên tập tin</th>
                                            <th>Ngày tạo</th>
                                            <th>Thao tác</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {!!evidences && evidences.map((evidence, index) =>
                                            <BPContestEvidenceRow
                                                key={'Evidence_'+evidence?.bankCode+'_'+evidence?.id}
                                                item={evidence} index={index}
                                                onLoadMessage={this.handleLoadMessage}
                                                onLoading={this.handleLoading}
                                                onLoadEvidences={this.handleLoadEvidences}
                                                contestId={item?.id} />
                                            )
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Link to={'/bp/contest'} className="btn btn-success">Quay về</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
export default BPContestDetailByAGBHO;